/* eslint-disable */
import React from "react";
import { Commodities } from '../../../controls/Commodities';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";
import { SLIDE_NUMBER } from "../constants";
import { orderBy } from "lodash";
import { equal } from "../../../../../shared";

interface CommoditiesControlItem {
    id: string;
    name: string;
    parent?: string,
    olapCommodity: number,
    origin: number,
    disabled: boolean,
}

export const CommoditiesControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<CommoditiesControlItem[]>([]);
    const [defaultCommodityValue, setDefaultCommodityValue] = React.useState<number[] | undefined>();
    const [commodityDisplay, setCommodityDisplay] = useParameter<number[] | null>("@commodities_display");
    const [commodityValue, setCommodityValue] = useParameter<number[] | null>("@commodities");

    React.useEffect(function initDefaultValue() {
        if (defaultCommodityValue === undefined && commodityValue !== null) {
            setDefaultCommodityValue(commodityValue);
        }
    }, [defaultCommodityValue, commodityValue]);

    const [dictItems] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
        business_unit: 1,
        slide: SLIDE_NUMBER,
    });

    React.useEffect(function updateControlItems() {
        if (dictItems) {
            const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
            const nextControlItems = sortedDictItems.map<CommoditiesControlItem>(dictItem => ({
                id: dictItem.id,
                origin: Number(dictItem.id),
                name: [
                    (dictItem.getValue("name") as any)[9] as string,
                    dictItem.getValue("comment") as string,
                ].filter(Boolean).join(', '),
                parent: dictItem.getValue<number>("parent")?.toString(),
                olapCommodity: Number(dictItem.getValue<number>("olap_commodity")),
                disabled: dictItems.some(x => x.getValue<number>('parent')?.toString() === dictItem.id),
            }));
            setControlItems(nextControlItems);

            let selectedItems = nextControlItems.filter(item => commodityValue?.includes(item.olapCommodity));
            if (selectedItems.length) {
                const defaultItem = nextControlItems.filter(item => defaultCommodityValue?.includes(item.olapCommodity));
                const firstItem = nextControlItems[0];
                selectedItems = defaultItem || firstItem;
            }
            
            if (equal(commodityDisplay, selectedItems.map(x => x.origin))) {
                setCommodityDisplay(selectedItems.map(x => x.origin));
            }
            if (equal(commodityValue, selectedItems.map(x => x.olapCommodity))) {
                setCommodityValue(selectedItems.map(x => x.olapCommodity));
            }
        }
    }, [dictItems]);

    const onChange = React.useCallback(values => {
        const selectedIds = values as string[];
        const selectedItems = controlItems.filter(item => selectedIds.includes(item.id));
        if (selectedItems) {
            setCommodityDisplay(selectedItems.map(item => item.origin));
            setCommodityValue(selectedItems.map(item => item.olapCommodity));
        }
    }, [controlItems, commodityValue, commodityDisplay]);

    const loader = React.useMemo(() => {
        return <Skeleton variant="rect" width="168px" height="51px" />;
    }, []);

    const control = React.useMemo(() => {
        const value = commodityDisplay?.map(String);
        return <Commodities large label="Commodity" multiple items={controlItems} value={value} onChange={onChange} />
    }, [controlItems, commodityDisplay, onChange]);

    const loading = [commodityDisplay, controlItems.length].some(x => !Boolean(x));
    return loading ? loader : control;
};
